import ShapeRect from "../../shapes/Rect.js";
import renderShape from "../../util/renderShape.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LegendShape(_ref) {
  let {
    shape = ShapeRect,
    width,
    height,
    margin,
    label,
    item,
    itemIndex,
    fill,
    size,
    shapeStyle
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "visx-legend-shape",
    style: {
      display: 'flex',
      width: size ? size({
        ...label
      }) : width,
      height: size ? size({
        ...label
      }) : height,
      margin
    },
    children: renderShape({
      shape,
      item,
      itemIndex,
      label,
      width,
      height,
      fill,
      shapeStyle
    })
  });
}